import React, { FC } from 'react'

import { BlockTypeWithGlobal } from '@Generated/graphql'
import { useBlockComponents } from '@Globals/CMS/useBlockComponents'

export interface FacetDescriptionContentProps {
  blocks: BlockTypeWithGlobal[]
  id: string
}

export const FacetDescriptionContent: FC<FacetDescriptionContentProps> = ({ blocks, id }) => {
  const components = useBlockComponents(blocks)
  return (
    <div id={id}>
      {components}
    </div>
  )
}
